import { AxiosError } from 'axios';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { orderApiService } from 'api/order/order-api.service';
import { parseAxiosError } from 'utils/errors';

export interface TrackOrderParams {
  orderNumber: string;
  email: string;
}

export const trackOrder = createAsyncThunk(
  'customer-service/track-order',
  async ({ orderNumber, email }: TrackOrderParams, { rejectWithValue }) => {
    try {
      const firstResponse = await orderApiService.trackOrder(
        orderNumber,
        email,
      );
      const firstData = firstResponse.data;

      const newNumber = firstData?.order?.newNumber;

      if (newNumber) {
        const secondResponse = await orderApiService.trackOrder(
          newNumber,
          email,
        );
        return secondResponse.data;
      }

      return firstData;
    } catch (err) {
      return rejectWithValue(parseAxiosError(<AxiosError>err));
    }
  },
);

export const trackEnterpriseOrder = createAsyncThunk(
  'customer-service/track-enterprise-order',
  async ({ orderNumber, email }: TrackOrderParams, { rejectWithValue }) => {
    try {
      const { data } = await orderApiService.trackOrder(orderNumber, email);
      return data;
    } catch (err) {
      return rejectWithValue(parseAxiosError(<AxiosError>err));
    }
  },
);
